export default defineNuxtRouteMiddleware((to, from) => {
  // 获取所有定义的路由
  const router = useRouter()
  const routes = router.getRoutes()
  
  // 检查目标路由是否存在
  const routeExists = routes.some(route => 
    route.path === to.path || 
    route.name === to.name ||
    route.path === to.path.split('?')[0] // 忽略查询参数
  )
  
  // 如果路由不存在，重定向到首页
  if (!routeExists) {
    return navigateTo('/', { replace: true })
  }
  
  // 继续正常路由
  return
})
